let application = {
    applicationName: "应用名称",
    enterApplicationName: "请输入应用名称",

    applicationKey: "应用标识",
    applicationSecret: "应用安全密钥",
    messageDataServerUrl: "消息服务地址",
    addApplication: "添加应用",
    updateApplication: "编辑应用",
    applicationDetail: "应用详情",
    updateSecret: "更新密钥",
    confirmDeleteCheckedApplication: "确定要删除此应用？",
    pleaseSelectApplication:"请选择应用"
}

export default application
